export default __webpack_public_path__ + "334a5b053929683f2113caefc8edb470.png";